// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Ui from "./ui.bs.js";
import * as React from "react";
import * as ReactDOMRe from "reason-react/src/legacy/ReactDOMRe.bs.js";

((require('./index.css')));

ReactDOMRe.renderToElementWithId(React.createElement(Ui.App.make, {
          message: "Minesweeper in ReScript & React"
        }), "root");

export {
  
}
/*  Not a pure module */
